export default __webpack_public_path__ + "static/media/organization-logo.50865dd3.svg";